<div class="flex flex-col place-content-start place-items-center mt-36">
  <div class="confirm-icon-container">
    <mat-icon class="confirm-icon">
      check_circle_filled
    </mat-icon>
  </div>
  <h3 class="confirmation-header">Success</h3>
  <h4>Work order {{workOrderId}} for {{customerName}} has been successfully created.</h4>
  <a routerLink="/">
    <h4>Return to Daily View</h4>
  </a>
</div>